import { TrackingPageRootComponent } from './tracking-page-root';
import { TrackingPageSearchPageComponent } from './tracking-page-search/tracking-page-search.component';
import { TrackingPageNumbersComponent } from './tracking-page-numbers';
// import { TrackingPageSearchPageComponent } from './tracking-page-search-page.component';

export const CONTAINERS = [
  TrackingPageRootComponent,
  TrackingPageNumbersComponent,
  TrackingPageSearchPageComponent
  // TrackingPageSearchPageComponent
];

export {
  TrackingPageRootComponent,
  TrackingPageNumbersComponent,
  // TrackingPageSearchComponent,
  TrackingPageSearchPageComponent
};
